/** The browser's local time as an ISO instant with its UTC offset made explicit, which is what the API's `contactedAt` accepts. */
export function toContactedAt(local: Date): string {
  return local.toISOString();
}

/** Shown in the viewer's own time zone: "6 Oct 2026, 14:30". */
export function formatContactedAt(iso: string): string {
  return new Intl.DateTimeFormat('en-KE', { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(iso));
}
